import * as actions from "./actionTypes";
import * as config from "config";
import ObjectToQueryString from 'utils/ObjectToQueryString';

export function getAllEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployees,
            method: "post",
            data: params,
            onStart: actions.GET_ALL_EMPLOYEES_START,
            onSuccess: actions.GET_ALL_EMPLOYEES,
            onError: actions.GET_ALL_EMPLOYEES_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getAllAcceptedEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployees,
            method: "post",
            data: params,
            onStart: actions.GET_ALL_ACCEPTED_EMPLOYEES_START,
            onSuccess: actions.GET_ALL_ACCEPTED_EMPLOYEES,
            onError: actions.GET_ALL_ACCEPTED_EMPLOYEES_FAILED,
        },
    }
}

export function downloadGetAllEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployees,
            method: "post",
            data: params,
            onStart: actions.DOWNLOAD_GET_ALL_EMPLOYEES_START,
            onSuccess: actions.DOWNLOAD_GET_ALL_EMPLOYEES,
            onError: actions.DOWNLOAD_GET_ALL_EMPLOYEES_FAILED,
        },
    }
}

export function downloadGetAllAcceptedEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployees,
            method: "post",
            data: params,
            onStart: actions.DOWNLOAD_GET_ALL_ACCEPTED_EMPLOYEES_START,
            onSuccess: actions.DOWNLOAD_GET_ALL_ACCEPTED_EMPLOYEES,
            onError: actions.DOWNLOAD_GET_ALL_ACCEPTED_EMPLOYEES_FAILED,
        },
    }
}

export function resendInvite(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiResendEmployeeODPcode,
            method: "post",
            data: params,
            onStart: actions.RESEND_INVITE_START,
            onSuccess: actions.RESEND_INVITE,
            onError: actions.RESEND_INVITE_FAILED,
        },
    }
}

export function createEmployee(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiCreateEmployee,
            method: "post",
            data: params,
            onStart: actions.CREATE_EMPLOYEE_START,
            onSuccess: actions.CREATE_EMPLOYEE,
            onError: actions.CREATE_EMPLOYEE_FAILED,
        },
    }
}

export function uploadEmployeesCsv(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUploadEmployeeCsv,
            method: "post",
            data: params,
            onStart: actions.UPLOAD_EMPLOYEE_START,
            onSuccess: actions.UPLOAD_EMPLOYEE,
            onError: actions.UPLOAD_EMPLOYEE_FAILED,
        },
    }
}

export function uploadEmployeesExcelPrevew(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUploadEmployeeExcelPreview,
            method: "post",
            data: params,
            onStart: actions.UPLOAD_EMPLOYEE_PREVIEW_START,
            onSuccess: actions.UPLOAD_EMPLOYEE_PREVIEW,
            onError: actions.UPLOAD_EMPLOYEE_PREVIEW_FAILED,
        },
    }
}

export function uploadEmployeePreviewSuccessReset() {
    return {
        type: actions.UPLOAD_EMPLOYEE_PREVIEW_SUCCESS_RESET,
        payload: {},
    }
}

export function uploadEmployeesExcel(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUploadEmployeeExcel,
            method: "post",
            data: params,
            onStart: actions.UPLOAD_EMPLOYEE_QUEUE_START,
            onSuccess: actions.UPLOAD_EMPLOYEE_QUEUE,
            onError: actions.UPLOAD_EMPLOYEE_QUEUE_FAILED,
        },
    }
}

export function uploadEmployeesExcelStatus(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUploadEmployeeExcelStatus + id,
            method: "get",
            data: {},
            onStart: actions.UPLOAD_EMPLOYEE_STATUS_START,
            onSuccess: actions.UPLOAD_EMPLOYEE_STATUS,
            onError: actions.UPLOAD_EMPLOYEE_STATUS_FAILED,
        },
    }
}

export function resetUploadEmployeeStatus() {
    return {
        type: actions.UPLOAD_EMPLOYEE_STATUS_RESET,
        payload: {},
    }
}

export function resetEmployeeCreateSuccess() {
    return {
        type: actions.CREATE_EMPLOYEE_RESET,
        payload: {},
    }
}

export function getEmployee(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployee + id,
            method: "get",
            data: {},
            onStart: actions.GET_EMPLOYEE_START,
            onSuccess: actions.GET_EMPLOYEE,
            onError: actions.GET_EMPLOYEE_FAILED,
        },
    }
}

export function editEmployee(id, params) {
  return {
    type: config.apiRequestStart,
    payload: {
      url: config.apiUpdateEmployee + id,
      method: 'put',
      data: params,
      onStart: actions.UPDATE_EMPLOYEE_START,
      onSuccess: actions.UPDATE_EMPLOYEE,
      onError: actions.UPDATE_EMPLOYEE_FAILED,
    },
  };
}

export function resetEmployeeEditSuccess() {
    return {
        type: actions.UPDATE_EMPLOYEE_RESET,
        payload: {},
    }
}

export function stopEmployeeEarning(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiStopEmployeeEarning + id,
            method: "post",
            data: params,
            onStart: actions.STOP_EMPLOYEE_EARNING_START,
            onSuccess: actions.STOP_EMPLOYEE_EARNING,
            onError: actions.STOP_EMPLOYEE_EARNING_FAILED,
        },
    }
}

export function resumeEmployeeEarning(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiResumeEmployeeEarning + id,
            method: "post",
            data: {},
            onStart: actions.RESUME_EMPLOYEE_EARNING_START,
            onSuccess: actions.RESUME_EMPLOYEE_EARNING,
            onError: actions.RESUME_EMPLOYEE_EARNING_FAILED,
        },
    }
}

export function pauseEmployeeWithdrawal(id) {
  return {
    type: config.apiRequestStart,
    payload: {
    //   baseUrl: config.apiGrossPayrollBaseUrl,
      url: config.apiPauseWithdrawal + id,
      method: 'post',
      data: {},
      onStart: actions.PAUSE_EMPLOYEE_WITHDRAWAL_START,
      onSuccess: actions.PAUSE_EMPLOYEE_WITHDRAWAL,
      onError: actions.PAUSE_EMPLOYEE_WITHDRAWAL_FAILED,
    },
  };
}

export function resumeEmployeeWithdrawal(id) {
  return {
    type: config.apiRequestStart,
    payload: {
    //   baseUrl: config.apiGrossPayrollBaseUrl,
      url: config.apiResumeWithdrawal + id,
      method: 'post',
      data: {},
      onStart: actions.RESUME_EMPLOYEE_WITHDRAWAL_START,
      onSuccess: actions.RESUME_EMPLOYEE_WITHDRAWAL,
      onError: actions.RESUME_EMPLOYEE_WITHDRAWAL_FAILED,
    },
  };
}

export function activateEmployee(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiEnableEmployee + id,
            method: "post",
            data: {},
            onStart: actions.ENABLE_EMPLOYEE_START,
            onSuccess: actions.ENABLE_EMPLOYEE,
            onError: actions.ENABLE_EMPLOYEE_FAILED,
        },
    }
}

export function bulkActivateEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiBulkActivateEmployee,
            method: "post",
            data: params,
            onStart: actions.BULK_ENABLE_EMPLOYEE_START,
            onSuccess: actions.BULK_ENABLE_EMPLOYEE,
            onError: actions.BULK_ENABLE_EMPLOYEE_FAILED,
        },
    }
}

// export function deactivateEmployee(id, params) {
export function deactivateEmployee(id) {
    return {
      type: config.apiRequestStart,
      payload: {
        url: config.apiDisableEmployee + id,
        method: 'post',
        data: {},
        onStart: actions.DISABLE_EMPLOYEE_START,
        onSuccess: actions.DISABLE_EMPLOYEE,
        onError: actions.DISABLE_EMPLOYEE_FAILED,
      },
    };
}

export function bulkDeactivateEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiBulkDeactivateEmployee,
            method: "post",
            data: params,
            onStart: actions.BULK_DISABLE_EMPLOYEE_START,
            onSuccess: actions.BULK_DISABLE_EMPLOYEE,
            onError: actions.BULK_DISABLE_EMPLOYEE_FAILED,
        },
    }
}

export function archiveEmployee(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiArchiveEmployee + id + "/archive",
            method: "post",
            data: {},
            onStart: actions.ARCHIVE_EMPLOYEE_START,
            onSuccess: actions.ARCHIVE_EMPLOYEE,
            onError: actions.ARCHIVE_EMPLOYEE_FAILED,
        },
    }
}

export function bulkArchiveEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiBulkArchiveEmployee,
            method: "post",
            data: params,
            onStart: actions.BULK_ARCHIVE_EMPLOYEE_START,
            onSuccess: actions.BULK_ARCHIVE_EMPLOYEE,
            onError: actions.BULK_ARCHIVE_EMPLOYEE_FAILED,
        },
    }
}

export function generateEraEmployee(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGenerateEraEmployee,
            method: "post",
            data: params,
            onStart: actions.GENERATE_ERA_EMPLOYEE_START,
            onSuccess: actions.GENERATE_ERA_EMPLOYEE,
            onError: actions.GENERATE_ERA_EMPLOYEE_FAILED,
        },
    }
}

export function getAllTransactions(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetTransactions + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_TRANSACTIONS_START,
            onSuccess: actions.GET_TRANSACTIONS,
            onError: actions.GET_TRANSACTIONS_FAILED,
        },
    }
}

export function resetReloadPage() {
    return {
        type: actions.RELOAD_PAGE_RESET,
        payload: {},
    }
}

export function getAllCRMEmployees() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetCRMEmployees,
            method: "get",
            data: {},
            onStart: actions.GET_EMPLOYEES_START,
            onSuccess: actions.GET_EMPLOYEES,
            onError: actions.GET_EMPLOYEES_FAILED,
            baseUrl: "https://crm-stg.earnipay.com/v1",
        },
    }
}

export function downloadGetAllCRMEmployees() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetCRMEmployees,
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_GET_ALL_EMPLOYEES_START,
            onSuccess: actions.DOWNLOAD_GET_ALL_EMPLOYEES,
            onError: actions.DOWNLOAD_GET_ALL_EMPLOYEES_FAILED,
            baseUrl: "https://crm-stg.earnipay.com/v1",
        },
    }
}

export function getEmployeeMetrics() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployeeMetrics,
            method: "get",
            data: {},
            onStart: actions.GET_EMPLOYEES_METRICS_START,
            onSuccess: actions.GET_EMPLOYEES_METRICS,
            onError: actions.GET_EMPLOYEES_METRICS_FAILED,
        },
    }
}

export function getPreviousMonthEmployeeMetrics(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: `${config.apiGetEmployeeMetrics}?from=${params?.from}&to=${params?.to}`,
            method: "get",
            data: {},
            onStart: actions.GET_PREV_MONTH_EMPLOYEES_METRICS_START,
            onSuccess: actions.GET_PREV_MONTH_EMPLOYEES_METRICS_DONE,
            onError: actions.GET_PREV_MONTH_EMPLOYEES_METRICS_FAILED,
        },
    }
}

export function inviteEmployees(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiInviteEmployees,
            method: "post",
            data: params,
            onStart: actions.INVITE_TO_ODP_START,
            onSuccess: actions.INVITE_TO_ODP,
            onError: actions.INVITE_TO_ODP_FAILED,
        },
    }
}

export function inviteGroups(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiInviteGroups,
            method: "post",
            data: params,
            onStart: actions.INVITE_TO_ODP_START,
            onSuccess: actions.INVITE_TO_ODP,
            onError: actions.INVITE_TO_ODP_FAILED,
        },
    }
}

export function resetInviteEmployeeGroup() {
    return {
        type: actions.INVITE_TO_ODP_RESET,
        payload: {},
    }
}

export function getAllEmployeesRole() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetEmployeesRole,
            method: "get",
            data: {},
            onStart: actions.GET_EMPLOYEE_START_ROLES,
            onSuccess: actions.GET_EMPLOYEE_ROLES,
            onError: actions.GET_EMPLOYEE_FAILED_ROLES,
            // useLoginJwt: false,
        },
    }
}

export function deleteAnEmployee(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiDeleteAnEmployee,
            method: "delete",
            data: params,
            onStart: actions.DELETE_EMPLOYEE_START,
            onSuccess: actions.DELETE_EMPLOYEE,
            onError: actions.DELETE_EMPLOYEE_FAILED,
            // useLoginJwt: false,
        },
    }
}
